/**
 * TenantPagination Component
 *
 * Renders pagination controls for the tenants table.
 *
 * @module features/tenants/components/TenantTable/TenantPagination
 */

import React from 'react';

interface TenantPaginationProps {
  page: number;
  pageSize: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
}

export const TenantPagination: React.FC<TenantPaginationProps> = ({
  page,
  pageSize,
  totalPages,
  total,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="pagination" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px',
      borderTop: '1px solid rgba(255, 255, 255, 0.08)'
    }}>
      <span className="text-secondary">
        Showing {((page - 1) * pageSize) + 1}-{Math.min(page * pageSize, total)} of {total}
      </span>
      <div className="flex gap-2">
        <button
          className="btn btn-ghost btn-sm"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <span style={{ padding: '0 12px', lineHeight: '32px' }}>
          Page {page} of {totalPages}
        </span>
        <button
          className="btn btn-ghost btn-sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};
